export default [
  {
    path: '/student/evaluations/Appointment',
    name: 'evaluations-appointment',
    component: () => import('@/views/evaluations/appointment/Appointment.vue'),
    meta: { IsParent: true },
  },
];
